import {
    Component,
    ComponentInterface,
    Element,
    h,
    Host,
    Prop,
    forceUpdate,
} from "@stencil/core";
import { i18nProvider } from "@trumpf/ux.i18n";
import {
    FilterDataProvider,
    FilterDataProviderState,
    getFilterDataProvider,
} from "../../apis/stateful-content";

@Component({
    tag: "ux-iws-stateful-filter-remove-button",
})
export class StatefulRemoveFilterButton implements ComponentInterface {
    private baseClass = "ux-iws-stateful-filter-remove-button";
    private filterProvider: FilterDataProvider;

    @Element() domNode: HTMLUxIwsStatefulFilterRemoveButtonElement;

    /** print debug info */
    @Prop() debug: boolean = false;
    /** scope used to retrieve the filter data provider */
    @Prop() scope: string = "";
    /** defines the layout of the button */
    @Prop() variant: "tag" | "primary" | "secondary" = "tag";
    /** defines if button should be full-width */
    @Prop() fullWidth: boolean = false;

    private _log = (...args: any[]) => {
        if (this.debug && console && typeof console.log === "function") {
            console.log(`[Stateful-Filter-Remove-Button]:`, ...args);
        }
    };

    private i18nSubscriberId: string;

    connectedCallback() {
        this.i18nSubscriberId = i18nProvider.subscribe(() => forceUpdate(this));
    }

    disconnectedCallback() {
        i18nProvider.unsubscribe(this.i18nSubscriberId);
    }

    componentWillLoad() {
        this.filterProvider = getFilterDataProvider(this.scope);
        this.filterProvider.subscribe(this.handleFilterProviderState);
        this.filterProvider.getData();
    }

    private handleFilterProviderState = ({
        filterData,
        filterQuery,
    }: FilterDataProviderState) => {
        if (filterData === null) {
            return;
        }
        this._log(`handleFilterProviderState filterQuery: "${filterQuery}"`);
    };

    private handleRemoveAll = () => {
        const sidebar = this.domNode.closest("ux-sidebar");
        const filter = sidebar?.querySelector(
            `ux-iws-stateful-filter[scope="${this.scope}"]`
        ) as HTMLUxIwsStatefulFilterElement | null;

        if (sidebar !== null && filter !== null) {
            filter.changeFilterQuery("");
            this.filterProvider.setFilterQuery("");
            sidebar.toggleSidebar();
        } else {
            this.filterProvider.setFilterQuery("");
        }
    };

    render() {
        const { t } = i18nProvider;

        return (
            <Host class={this.baseClass}>
                {this.variant === "tag" && (
                    <span
                        class="ux-filter__remove-all"
                        role="button"
                        onClick={this.handleRemoveAll}
                    >
                        {t("filter.clearAll")}
                        <ux-icon name="close" />
                    </span>
                )}
                {(this.variant === "secondary" ||
                    this.variant === "primary") && (
                    <button
                        class={`ux-button ux-button--${this.variant} ${
                            this.fullWidth ? "ux-button--full-width" : ""
                        }`}
                        onClick={this.handleRemoveAll}
                    >
                        {t("filter.clearAll")}
                    </button>
                )}
            </Host>
        );
    }
}
